import styled from '@emotion/styled';

import { mq } from '@clutter/clean';

export const FAQsSection = styled.section`
  background: white;
  padding: 60px 0 60px 0;

  ${mq({
    padding: ['60px 0 0px 0', '60px 0 100px 0', '60px 0 60px 0'],
  })}
`;

export const Container = styled.div`
  width: 1050px;
  height: auto;
  min-height: 787px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  position: relative;

  ${mq({
    width: ['100%', '100%', '1050px'],
    height: ['auto', 'auto', 'auto'],
    minHeight: ['auto', 'auto', '787px'],
    padding: ['0 20px', '0 24px', '0 32px'],
    gap: ['16px', '20px', '24px'],
  })}
`;

export const SectionHeading = styled.h2`
  width: 964px;
  height: 66px;
  font-family: 'Recoleta';
  font-size: 40px;
  font-weight: 500;
  font-style: normal;
  color: #000000;
  margin-bottom: 60px;
  line-height: 140%;
  letter-spacing: 0px;

  ${mq({
    width: ['100%', '100%', '964px'],
    height: ['auto', 'auto', '66px'],
    fontSize: ['40px', '38px', '45px'],
    marginBottom: ['4px', '24px', '0px'],
  })}

  /* Mobile-specific styles */
  @media (max-width: 768px) {
    color: var(--Text-Panther, #000);
    font-feature-settings:
      'liga' off,
      'clig' off;
    font-family: Recoleta;
    font-size: 40px;
    font-style: normal;
    font-weight: 500;
    line-height: 44px; /* 110% */
  }
`;

export const FAQContainer = styled.div`
  max-width: 964px;
  width: 964px;
  height: auto;
  display: flex;
  flex-direction: column;
  gap: 24px;

  ${mq({
    width: ['100%', '100%', '964px'],
    height: ['auto', 'auto', 'auto'],
    gap: ['0px', '4px', '8px'],
  })}
`;

export const FAQItem = styled.div`
  display: flex;
  flex-direction: column;
  width: 964px;
  height: auto;
  min-height: fit-content;
  gap: 16px;
  margin-bottom: 24px;
  padding-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
    padding-bottom: 40px;

    ${mq({
      paddingBottom: ['24px', '32px', '40px'],
    })}
  }

  ${mq({
    width: ['100%', '100%', '964px'],
    gap: ['4px', '6px', '8px'],
    paddingBottom: ['0px', '4px', '0px'],
    marginBottom: ['16px', '20px', '24px'],
  })}
`;

export const FAQQuestion = styled.button<{ expanded: boolean }>`
  width: 964px;
  height: fit-content;
  min-height: 39px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 32px 0;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  font-family: 'Recoleta';
  font-size: 28px;
  font-weight: 500;
  font-style: normal;
  color: #000000;
  line-height: 140%;
  letter-spacing: 0px;

  ${mq({
    width: ['100%', '100%', '964px'],
    minHeight: ['auto', 'auto', '39px'],
    fontSize: ['24px', '26px', '28px'],
    padding: ['12px 0', '12px 0', '16px 0'],
  })}
`;

export const QuestionText = styled.span`
  width: 572px;
  height: auto;
  font-family: 'Recoleta';
  font-size: 28px;
  font-weight: 500;
  font-style: normal;
  color: #000000;
  line-height: 140%;
  letter-spacing: 0px;
  flex: 1;
  padding-right: 16px;

  ${mq({
    width: ['calc(100% - 48px)', 'calc(100% - 52px)', '572px'],
    fontSize: ['24px', '26px', '28px'],
    paddingRight: ['12px', '14px', '16px'],
  })}

  /* Mobile-specific styles */
  @media (max-width: 768px) {
    color: var(--Typography-Panther, #000);
    font-feature-settings:
      'liga' off,
      'clig' off;
    font-family: Recoleta;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 140%; /* 28px */
  }
`;

export const FAQAnswer = styled.div`
  width: 964px;
  height: auto;
  min-height: 100px;
  font-family:
    'Basier Square',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    'Roboto',
    'Oxygen',
    'Ubuntu',
    'Cantarell',
    'Fira Sans',
    'Droid Sans',
    'Helvetica Neue',
    sans-serif;
  font-size: 18px;
  font-weight: 400;
  font-style: normal;
  line-height: 140%;
  letter-spacing: 0;
  color: #000000;
  padding: 0 0 16px 0;
  transition: all 0.3s ease;

  ul,
  ol {
    margin: 16px 0;
    padding-left: 24px;
  }

  ul {
    list-style-type: disc;
  }

  ol {
    list-style-type: decimal;
  }

  li {
    margin-bottom: 8px;
    line-height: 140%;
  }

  strong {
    font-weight: 600;
  }

  br {
    line-height: 140%;
  }

  ${mq({
    width: ['100%', '100%', '964px'],
    height: ['auto', 'auto', 'auto'],
    fontSize: ['16px', '17px', '18px'],
    padding: ['0 0 8px 0', '0 0 12px 0', '0 0 16px 0'],
  })}

  /* Mobile-specific styles */
  @media (max-width: 768px) {
    color: var(--Typography-Panther, #000);
    font-feature-settings:
      'liga' off,
      'clig' off;
    font-family: 'Basier Square';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%; /* 22.4px */

    ul,
    ol {
      margin: 12px 0;
      padding-left: 20px;
    }

    li {
      margin-bottom: 6px;
    }
  }

  @media (min-width: 769px) and (max-width: 1024px) {
    ul,
    ol {
      margin: 14px 0;
      padding-left: 22px;
    }

    li {
      margin-bottom: 7px;
    }
  }
`;

export const ExpandIcon = styled.span<{ expanded: boolean }>`
  width: 36px;
  height: 36px;
  border-radius: 128.57px;
  background-color: ${(props) => (props.expanded ? '#D9D9D9' : '#097e77')};
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-left: 20px;
  padding: 6px;
  transition: transform 0.2s ease;

  svg {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    aspect-ratio: 1/1;
  }

  ${mq({
    width: ['32px', '34px', '36px'],
    height: ['32px', '34px', '36px'],
    marginLeft: ['16px', '18px', '20px'],
    padding: ['4px', '5px', '6px'],
  })}

  /* Mobile-specific styles for SVG */
  @media (max-width: 768px) {
    svg {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: var(--M, 24px);
      align-self: stretch;
    }
  }
`;
